import apiCall from "../accounting/remote/apiCall";

/**
 * What is left of the old accounting ajax, for the two screens outside the
 * accounting module that used it.
 *
 *   Components/Users/CreateDeposit.jsx    — team-member deposits
 *   Pages/PayRate/CreateTaskPayment.jsx   — team task payments
 *
 * Both posted straight into the previous accounting module, naming a debit and
 * a credit ledger from its chart of accounts. That module has been replaced and
 * those ledgers are gone, so recording is disabled in both screens; only the
 * account lists that populate their dropdowns are still wired, and those map
 * cleanly onto the new module.
 *
 * When the chart of accounts has been migrated and it is decided which accounts
 * a deposit and a task payment should hit, re-point them at
 * accounting/journal/create and delete this file.
 */

const disabled = (what) => async () => ({
  status: "Fail",
  message: `${what} is disabled while accounting is being migrated.`,
  details: false,
});

const ajaxAccounting = {
  // Direct equivalents in the new module.
  getALlLedgersMinData_cash_or_bank: (data) =>
    apiCall("accounting/accounts/list", { ...data, type: "asset", postable_only: 1 }),

  getALlLedgersMinData_non_cash_or_bank: (data) =>
    apiCall("accounting/accounts/list", { ...data, postable_only: 1 }),

  // Turned off at the screens themselves; these are the backstop.
  createDepositTransaction: disabled("Recording deposits"),
  createcreditTransaction: disabled("Recording task payments"),
};

export default ajaxAccounting;
